(() => {
  const btn = document.querySelector('.image-text-button-grid-cards .btn--link-light');

  const changeThemeBtn = () => {
    if (window.matchMedia('(min-width: 992px)').matches) {
      if (!btn.classList.contains('btn--link')) {
        btn.classList.remove('btn--primary-light');
        btn.classList.add('btn--link', 'btn--link-light');
      }
    } else {
      if (!btn.classList.contains('btn--primary-light')) {
        btn.classList.remove('btn--link', 'btn--link-light');
        btn.classList.add('btn--primary-light');
      }
    }
  };

  changeThemeBtn();

  window.addEventListener('resize', changeThemeBtn);
})();
